export default __webpack_public_path__ + "static/media/muyap_yatay.60ef74ff.png";